/* eslint-disable no-unused-vars */
import React, { useState } from 'react'
import SearchModal from '../modal/SearchModal'
import { PlusOutlined } from '@ant-design/icons'
import ExistingLoanSearchModal from '../modal/ExistingLoanSearchModal'

const DropdownBtn = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [selectedOption, setSelectedOption] = useState(null)
  const [showModal, setShowModal] = useState(false)
  const [isExistingCustomerModalOpen, setIsExistingCustomerModalOpen] = useState(false)

  const options = ['Register a Company', 'Apply for loan', 'Apply for existing customer']

  const handleDropdownToggle = () => {
    setIsOpen(!isOpen)
  }

  const handleOptionSelect = option => {
    setSelectedOption(option)
    setIsOpen(false)
    if (option === 'Apply for loan') {
      setShowModal(true)
      setIsExistingCustomerModalOpen(false)
    } else if (option === 'Apply for existing customer') {
      setIsExistingCustomerModalOpen(true)
      setShowModal(false)
    } else {
      setShowModal(false)
      setIsExistingCustomerModalOpen(false)
    }
  }

  const closeModal = () => {
    setShowModal(false)
    setIsExistingCustomerModalOpen(false)
  }

  return (
    <div className='relative z-10'>
      <button
        className='bg-primary hover:bg-primary-200 text-white font-medium rounded-lg px-4 py-2 flex items-center gap-2 transition-all duration-200 ease-in-out hover:shadow-md hover:scale-[1.02] active:scale-[0.98]'
        onClick={handleDropdownToggle}
      >
        <PlusOutlined className='text-sm' />
        <span>New Application</span>
      </button>
      {isOpen && (
        <div className='absolute top-11 right-0 mt-2 bg-white shadow-lg rounded-md z-20 min-w-[200px]'>
          {options.map((option, index) => {
            const shouldDisable = option !== 'Apply for loan'
            const shouldDisables = option !== 'Apply for existing customer'
            return (
              <button
                key={index}
                disabled={shouldDisable && shouldDisables}
                className={`${
                  shouldDisable && shouldDisables ? 'cursor-not-allowed' : ''
                } block w-full px-4 py-2 text-gray-800 hover:bg-blue-200 border-b-2 text-left`}
                onClick={() => handleOptionSelect(option)}
              >
                {option}
              </button>
            )
          })}
        </div>
      )}
      {showModal && selectedOption === 'Apply for loan' && (
        <SearchModal isOpen={showModal} onClose={closeModal} />
      )}
      {isExistingCustomerModalOpen && (
        <ExistingLoanSearchModal isOpen={isExistingCustomerModalOpen} onClose={closeModal} />
      )}
    </div>
  )
}

export default DropdownBtn
